import { render, staticRenderFns } from "./MetalBimChild.vue?vue&type=template&id=4df62ffd&scoped=true"
import script from "./MetalBimChild.vue?vue&type=script&lang=js"
export * from "./MetalBimChild.vue?vue&type=script&lang=js"
import style0 from "./MetalBimChild.vue?vue&type=style&index=0&id=4df62ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df62ffd",
  null
  
)

export default component.exports